// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lPWyM","colBig":"styles_colBig__3vJCA","colSmall":"styles_colSmall__2X_qk"};